module.exports = __webpack_public_path__ + "img/header.9fc4726d.png";